import type { IProductDomain } from '@/Interfaces/ProductDomains/ProductDomain.interface';
import classNames from 'classnames';

interface IProps {
  domains: IProductDomain[];
  className?: string;
}

const ProductDomainList = ({ domains, className }: IProps) => {
  if (!domains.length) return null;

  return (
    <div className={classNames('flex flex-col', className)}>
      <ul>
        {domains.map(domain => (
          <li key={domain.id} className='py-1 px-3 rounded-md hover:bg-[#1b43321f] cursor-default'>
            {domain.name}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ProductDomainList;
